// extracted by mini-css-extract-plugin
export default {"head-title":"Header_head-title__cGC2D","box-buttons":"Header_box-buttons__ObQSS"};